import { render, staticRenderFns } from "./CreateCampaignWidgetWidgetModal.vue?vue&type=template&id=faf80360&scoped=true&"
import script from "./CreateCampaignWidgetWidgetModal.vue?vue&type=script&lang=js&"
export * from "./CreateCampaignWidgetWidgetModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCampaignWidgetWidgetModal.vue?vue&type=style&index=0&id=faf80360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf80360",
  null
  
)

export default component.exports